import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useApp } from '../../../contexts/AppContext';
import { useToast } from '../../ui/Toast';
import { DELIVERY_ACTIVE, stationLabel } from '../../../utils/playlistDelivery';
import { deliveredToast, failedToast } from './playlistCopy';

/**
 * A delivery keeps running when the user leaves /playlist (spec S5); this
 * toasts its outcome there (TS-1 / TS-2). Renders nothing.
 */
export default function PlaylistDeliveryNotifier() {
  const { state } = useApp();
  const { pathname } = useLocation();
  const toast = useToast();
  const { delivery, name } = state.playlist;
  const previousStatus = useRef(delivery.status);

  useEffect(() => {
    const wasActive = DELIVERY_ACTIVE.includes(previousStatus.current);
    previousStatus.current = delivery.status;
    if (!wasActive || pathname === '/playlist') return;
    if (delivery.status === 'done') toast.success(deliveredToast(name, stationLabel(state.linkedAgents, delivery.agentId)));
    if (delivery.status === 'failed') toast.error(failedToast(name));
  }, [delivery.status]);

  return null;
}
